import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function ClosingCTA() {
  return <section className="bg-gradient-to-br from-[#1A1A1A] to-[#2C2C2A] text-center py-12 sm:py-[70px] px-5 text-white" data-id="element-51">
      <h2 className="text-[clamp(22px,4vw,36px)] font-extrabold max-w-[680px] mx-auto mb-4 leading-[1.2]" data-id="element-52">
        No dejes pasar esta oportunidad.
        <br data-id="element-53" />
        <span className="text-dorado" data-id="element-54">
          Tu próxima clienta te pregunta el precio hoy.
        </span>
      </h2>
      <p className="text-[15px] text-[#AAAAAA] max-w-[560px] mx-auto mb-6 sm:mb-9 leading-[1.65]" data-id="element-55">
        Podés responderle con un mensaje de texto improvisado como siempre — o
        podés mandarle un presupuesto profesional que hable por vos antes de que
        diga una sola palabra.
      </p>

      <div className="flex flex-col items-center gap-4" data-id="element-56">
        <a href="#precios" className="inline-block bg-gradient-to-br from-rosa to-rosa-oscuro text-white text-[17px] font-bold px-10 py-4 rounded-full shadow-[0_8px_30px_rgba(212,83,126,0.45)] hover:-translate-y-0.5 transition-transform tracking-wide" data-id="element-57">
          💅 QUIERO MI KIT PROFESIONAL AHORA
        </a>
        <div className="flex flex-wrap justify-center gap-4 text-[#888888] text-[13px]" data-id="element-58">
          <span className="flex items-center gap-1.5" data-id="element-59">
            <Lock size={16} data-id="element-60" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-61">
            <Zap size={16} data-id="element-62" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-63">
            <ShieldCheck size={16} className="text-verde" data-id="element-64" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-65">
            <CreditCard size={16} data-id="element-66" /> Mercado Pago
          </span>
        </div>
      </div>

      <div className="mt-8 sm:mt-10 pt-8 sm:pt-10 border-t border-white/10" data-id="element-67">
        <UrgencyBanner data-id="element-68" />
        <OfferSelector data-id="element-69" />
      </div>
    </section>;
}